import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  containerImage: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    borderRadius: '10%',
    objectFit: 'cover'
  },
  tablecell: {
    fontSize: '8pt'
  }
}));
